import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="flag-2, priority"><path d="M4.75 21.2498V15.0831M4.75 15.0831V3.77755C10.0003 1.18383 13.9997 6.37127 19.25 3.77755V15.0831C13.9997 17.6768 10.0003 12.4894 4.75 15.0831Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFlag2;
